


import { Component, Vue, Prop } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import { InspectButtonValue } from "@/model/InspectButtonValue";
import InputNumber from "@/components/common/input/InputNumber.vue";
import EstimateInspectionCostComponent from "@/components/EstimateInspectionCostComponent.vue";
import EstimateListComponent from "@/components/EstimateListComponent.vue";
import EstimatePreview from "@/components/EstimatePreview.vue";
import QuickInspectionCostComponent from "@/components/QuickInspectionCostComponent.vue";
import QuickInspectListComponent from "@/components/QuickInspectListComponent.vue";
import QuickMitsumoriContentPreview from "@/components/QuickMitsumoriContentPreview.vue";
import QuickCouponComponent from "@/components/QuickCouponComponent.vue";
import QuickOptionComponent from "@/components/QuickOptionComponent.vue";
import QuickOptionComponentNex from "@/components/QuickOptionComponentNex.vue";
import ConfirmDialog from "@/components/common/ConfirmDialog.vue";
import { CarSelectQuickInfoData } from "@/model/CarSelectionQuickInfo";
import { QuickMitsumoriQrInfo } from "@/model/quickMitsumoriQrInfo";
import Number from "@/shared/filters/Number";

import { Utils } from "@/service/util";
import { INSPECT_TYPE } from "@/model/InspectType";
import { CouponData } from "@/model/Coupon";
import { ShakenShohiyou } from "@/model/ShakenShohiyou";

import { DO_TENKEN } from "@/model/DoTenken";
import { SeibiItem } from "@/model/InspectionSeibi";
import { UserService } from "@/service/UserService";
import requestService from "@/service/requestService";
import loadingService from "@/service/loadingService";

import * as htmlToImage from 'html-to-image';
import { toPng, toJpeg, toBlob, toPixelData, toSvg } from 'html-to-image';
import EstimateDetail from "@/page/factory/estimateDetail.vue";

@Component({
  components: {
    InputNumber,
    EstimateInspectionCostComponent,
    EstimateListComponent,
    EstimatePreview,
    QuickInspectionCostComponent,
    QuickInspectListComponent,
    QuickMitsumoriContentPreview,
    QuickCouponComponent,
    QuickOptionComponent,
    QuickOptionComponentNex,
    ConfirmDialog
  },
  filters: { Number }
})
export default class QuickMitsumoriContent extends EstimateDetail {

  isModeTab: boolean = false;
  isModeQuick: boolean = true; // modeQuickFlgとは挙動が異なるかもしれない(要確認)

  $refs!: {
    estimateInspectionCostComponent: EstimateInspectionCostComponent;
    quickInspectionCostComponent: QuickInspectionCostComponent;
    quickCouponComponent: QuickCouponComponent;
    quickOptionComponent: QuickOptionComponent;
    quickOptionComponentNex: QuickOptionComponentNex;
    estimateListComponent: EstimateListComponent;
    dialog: ConfirmDialog;
    confirmDialogOnlyClose: ConfirmDialog;
    updateShakenShuruiDialog: ConfirmDialog;
    saveAndExitDialog: ConfirmDialog;
  };

  listPrefectures: any = {};

  testmode: boolean = false; // 部品詳細展開

  isUserMode = false;
  seibiList: any = [];
  // couponKn: number = 0;
  shouhiyou: any = {
    houteiHiyou: {
      zeiJibaisekiZk: 0,
      zeiWeightTax: 0,
      zeiInshidaiZk: 0,
      zeiTechInfoAmountZk: 0, // 2021-10-12 sh #7458 add
    },
    kensaHiyou: {
      subTotalZk: 0
    },
    shakenHiyou: { subTotalZk: 0 }
  };
  total1 = 0;
  total2 = 0;
  companyInfo: any = {};

  inspectType: number = INSPECT_TYPE.RECOMMEND;

  showDialogInspectionCost: boolean = false;
  showDialogCoupon: boolean = false;
  showDialogEstimate: boolean = false;
  showDialogPreview: boolean = false;
  showDialogOption: boolean = false;

  loading: boolean = false; // クイック見積もりではローディングがない？
  preloadingQrInfo: boolean = false;

  public reqService: requestService = new requestService();
  loadingService: loadingService = new loadingService();
  public utils: Utils = new Utils();

/** 2023-10-20 一時的な対応：簡単見積機能を税込税抜切り替え対象から外す [START] */
  @Prop() modeQuickFlg: boolean; // isModeQuickとは挙動が違うかもしれない：要確認
/** 2023-10-20 一時的な対応：簡単見積機能を税込税抜切り替え対象から外す [END] */

  @Getter("hasData", { namespace: "Shohiyou" })
  hasCostData: boolean;
  @Getter("total", { namespace: "Shohiyou" })
  costDataTotal: any;
  @Getter("currentState", { namespace: "Shohiyou" })
  costData: ShakenShohiyou;
  @Getter("total", { namespace: "Coupon" })
  couponData: any;
  @Getter("total", { namespace: "Option" })
  optionData: any;

  @Getter("listInspectByType", { namespace: "InspectSeibi" })
  listInspect!: (inspectType: number) => SeibiItem[];

  @Getter("sumPriceByType", { namespace: "InspectSeibi" })
  sumPrice!: (inspectType: number) => any;

  @Getter("currentState", { namespace: "CarSelectionQuickInfo" })
  currentStateQuickInfo: CarSelectQuickInfoData;

  @Getter("currentState", { namespace: "QuickMitsumoriQrInfo" })
  currentStateQuickMitsumoriQrInfo: QuickMitsumoriQrInfo;

  @Action("setState", { namespace: "QuickMitsumoriQrInfo" })
  setStateQuickMitsumoriQrInfo: any;

  /** 2024-05-02 nextage [START] */
  @Getter("isNextageCustom", { namespace: "FunctionSetting" })
  isNextageCustom: any;
  /** 2024-05-02 nextage [END] */
  @Getter("isEstimateBuhin", { namespace: "FunctionSetting" })
  isEstimateBuhin: any;

  /** 2021-08-24 sh #7361 it does not update seibiList for quick mitsumori. [START] */
  seibiDataUnSubscribe: any = null;
  /** 2021-08-24 sh #7361 it does not update seibiList for quick mitsumori. [END] */

  created() {
    // console.log("QuickMitsumoriContent.created => CALL!!");
    this.isUserMode = this.$route.meta === "user";

    // this.couponKn = this.couponData.subTotalZk;
    this.shouhiyou = this.costData;

    this.isModeQuick = true;

    // this.total1 = this.shakenTotal();
    // this.total2 = this.calcTotal2();

    this.getSeibi();

    this.getCompanyInfo();
  }

  showDialogInspectionCostOpened() {
    // 車検費用モーダルの初回呼出表示までにrefしていた内容は実行されないのでここで処理する
    // 現状実質ダミー
  }

  showDialogEstimateListOpened() {
    // おすすめ整備モーダルの初回呼出表示までにrefしていた内容は実行されないのでここで処理する
    // 現状実質ダミー
  }

  getSeibi() {
    // console.log("QuickMitsumoriContent.getSeibi => CALL!!");
    // if (this.hasCostData) {

    // } else {
      const userService = new UserService();
      userService.getAllDataQM();
    // }
    setTimeout(() => {
      this.setListSeibi();
    }, 1000);
  }
  
  tesdt(item: any) {
    console.log("mode",item.buhinListDisp);
    item.buhinListDisp = !item.buhinListDisp;
    this.$forceUpdate();
  }

  setListSeibi() {
    let seibiList = this.listInspect(this.inspectType);
    // console.log("QuickMitsumoriContent.setListSeibi seibiList => ", seibiList);

    if (seibiList && seibiList.length > 0) {
      let tmpList = this.utils.deepCopy(seibiList);
      let filteredSeibiList = tmpList.filter((item: SeibiItem) => +item.doTenken == DO_TENKEN.suru)
        .map((e: any, index: number) => {
          // if (this.isEstimateBuhin) { // 部品リストを追加するかどうか判断する
          e.buhinListDisp = false; // 開く閉じるの初期値
          e.buhinListLoaded = true;
          e.buhinList = [];
          // this.reqService.getInspectSeibiAK3_2(this.uketsukeExtendsId, e.sknInspectSeibiId, 1, 2)
          // this.reqService.getInspectSeibiAK3_2(this.uketsukeExtendsId, e.sknUketsukeManualSeibiId, 1, 3)
          return e;
        });

      if ( filteredSeibiList && filteredSeibiList.length > 0) {
        this.seibiList = filteredSeibiList.sort((item1: SeibiItem, item2: SeibiItem) => {
          /** 2021-07-28 sh #6989 add sort for quick mitsumori.(priority 2) [START] */
          if (item1.sknRecommendInspectCategoryId > item2.sknRecommendInspectCategoryId) {
            return 1;
          }
          if (item1.sknRecommendInspectCategoryId < item2.sknRecommendInspectCategoryId) {
            return -1;
          }
          if (item1.sknInspectDescriptionSeibiId > item2.sknInspectDescriptionSeibiId) {
            return 1;
          }
          if (item1.sknInspectDescriptionSeibiId > item2.sknInspectDescriptionSeibiId) {
            return -1;
          }
          /** 2021-07-28 sh #6989 add sort for quick mitsumori.(priority 2) [END] */
          if (item1.sknInspectSeibiId > item2.sknInspectSeibiId) {
            return 1;
          }
          if (item1.sknInspectSeibiId < item2.sknInspectSeibiId) {
            return -1;
          }
          return 0;
        });
      } else {
        this.seibiList = filteredSeibiList;
      }

    }
    // this.showPriceList = this.utils.deepCopy(this.listSeibi);
  }

  isTriangle(item: any) {
    return item.inspectResult == InspectButtonValue.TRIANGLE;
  }

  isCross(item: any) {
    return item.inspectResult == InspectButtonValue.CROSS;
  }

  get dispJibaiseki() {
   return this.shouhiyou.houteiHiyou.zeiJibaisekiZk;
  }
  get dispWeightTax() {
   return this.shouhiyou.houteiHiyou.zeiWeightTax;
  }
  get dispInshidai() {
   return this.shouhiyou.houteiHiyou.zeiInshidaiZk;
  }
  get dispTechInfoAmount() {
   return this.shouhiyou.houteiHiyou.zeiTechInfoAmountZk;
  }

  get dispkensaHiyou() {
    return this.shouhiyou.kensaHiyou.subTotalZk;
  }

  dispShakenHiyouList(kazei: boolean) {
    if (this.shouhiyou.shakenHiyou && this.shouhiyou.shakenHiyou.items ) {
      if (kazei) {
        return this.shouhiyou.shakenHiyou.items;
      } else {
        return this.shouhiyou.shakenHiyou.items;
      }
    } else {
      return []; // 空配列
    }
  }

  get shakenTotal() {
    return (
      this.shouhiyou.kensaHiyou.subTotalZk +
      this.shouhiyou.houteiHiyou.zeiJibaisekiZk +
      this.shouhiyou.houteiHiyou.zeiWeightTax +
      this.shouhiyou.houteiHiyou.zeiInshidaiZk +
      /** 2021-10-12 sh #7458 implements tech-info-amount. [START] */
      (this.isUseTechInfoAmount ? this.shouhiyou.houteiHiyou.zeiTechInfoAmountZk : 0) +
      /** 2021-10-12 sh #7458 implements tech-info-amount. [END] */
      this.shouhiyou.shakenHiyou.subTotalKazeiZk +
      this.shouhiyou.shakenHiyou.subTotalHikazeiZk +
      /** 2021-04-08 sh add option [START] */
      // this.optionKn + this.couponKn + this.calcTotal2
      this.optionKn + this.couponKn + this.calcTotal2
      /** 2021-04-08 sh add option [END] */
    );
  }

  get calcTotal2() {
    return this.sumPrice(this.inspectType).totalZk;
  }

  get couponKn() {
    if (!this.couponData) {
      return 0;
    }
    return this.couponData.subTotalZk;
  }

  /** 2021-04-08 sh add option [START] */
  get optionKn() {
    if (!this.optionData) {
      return 0;
    }
    return this.optionData.subTotalZk;
  }
  /** 2021-04-08 sh add option [END] */

  sumItem(item: any) {
    return (item.buhinEditTotalZk || 0) + ( item.kouchinEditZk || 0);
  }

  onShowDialogInspectionCost() {
    this.showDialogInspectionCost = true;
  }

  onShowDialogCoupon() {
    /** 2024-09-26 ネクステージ用調整値引額機能の工場側動作補助 [START] */
    // 調整値引額の基準金額はユーザー側機能で共通化しているが、
    // 工場側では金額系が個別実装で必要な情報のロードを行わないので最新でない場合がある
    
    // 条件：ネクステージで工場側の動作で表示しており、合計金額が違う状態でクーポンをモーダル呼び出しする時
    // モーダル呼び出し関数内でチェックスキップ。合計金額の誤差チェックは税込表示時に時間がかかるので未実装
    if ( !this.isUserMode && this.isNextageCustom ) {
      const userService = new UserService();
      userService.getAllDataQM();
      // userService.getAllData();
    }
    /** 2024-09-26 ネクステージ用調整値引額機能の工場側動作補助 [END] */
    this.showDialogCoupon = true;
  }

  onShowDialogEstimate() {
    this.showDialogEstimate = true;
  }

  onCloseDialogInspectionCost() {
    this.$refs.quickInspectionCostComponent.onConfirm();
    this.showDialogInspectionCost = false;
    this.getSeibi();
  }

  onCloseDialogCoupon() {
    this.$refs.quickCouponComponent.onConfirm(1);
  }

  onCloseDialogCouponNext() {
    this.showDialogCoupon = false;
    this.getSeibi();
  }

  /** 2021-04-08 sh add option [START] */
  onShowDialogOption() {
    this.showDialogOption = true;
  }

  onCloseDialogOption() {
    this.$refs.quickOptionComponent.onConfirm(1);
  }

  onCloseDialogOptionNext() {
    this.showDialogOption = false;
    this.getSeibi();
  }
  /** 2021-04-08 sh add option [END] */

  onCloseDialogEstimate() {
    this.showDialogEstimate = false;
    this.getSeibi();
  }

  onUpdateInspectList() {
    this.getSeibi();
  }

  onShowPrintQuickMitsumori() {
    this.showDialogPreview = true;
  }

  onSubmit() {
    // デザイン統合用のダミー
  }

  /**
   * スクリーンショットを作成して、DBに保存する。
   * スクリーンショットは、URL情報があるQRを読み込めば確認できる
   *
   * 2021-10-11 sh タイミングをズラすために、setTimeoutを使っている。
   */
  onSaveQuickMitsumori() {
    this.loadingService.show();
    /** 2021-10-11 sh #7458 change layout at quick mitsumori. [START] */
    this.$set(this, "preloadingQrInfo", true);
    /** 2021-10-11 sh #7458 change layout at quick mitsumori. [START] */
  
    let node: any = document.getElementById('qm');
 
    setTimeout(()=> {
      htmlToImage.toPng(node).then((dataUrl: any) => {

        this.$set(this, "preloadingQrInfo", false);

        let objQrInfo = {
          ...this.currentStateQuickMitsumoriQrInfo,
          base64QrImage: dataUrl
        };

        this.reqService.saveQuickMitsumoriQrInfo(objQrInfo).then(()=> {
          this.$emit("onUpdateQuickMitsumoriQrInfo");
        });

        this.loadingService.hide();

      }).catch((error: any) => {
        console.error('oops, something went wrong!', error);
        this.$set(this, "preloadingQrInfo", false);
        this.loadingService.hide();
      });
    }, 500);
  }

  /**
   * windowsの印刷機能を利用して、印刷する
   * 2021-10-11 PDF方式に変更
   */
  /** 2021-10-11 sh #7458 change layout at quick mitsumori. [START] */
  // onPrintQuickMitsumori() {
  //  window.print();
  // }
  onPrintQuickMitsumori() {
    const id = this.currentStateQuickInfo.sknQuickMitsumoriId;
    this.loadingService.show();
    this.reqService.printQuickMitsumori(id).then((blob: any) => {
      this.loadingService.hide();
      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = '概算車検見積書.pdf'; // 2021-11-10 sh #7536 change name from 車検見積結果 to 概算車検見積書
      link.click();
    }, (err: any) => {
      this.loadingService.hide();
    });
  }
  /** 2021-10-11 sh #7458 change layout at quick mitsumori. [END] */

  onCloseDialogPreview() {
    this.showDialogPreview = false;
  }

  getCompanyInfo() {
    this.reqService.getPrefectures().then(list => {
      this.listPrefectures = list;

      this.reqService.getCompanyInfo().then((res)=> {
        if (res) {
          this.companyInfo = res;

          const pref = this.listPrefectures.filter( (e: any) => e.prefCd == this.companyInfo.prefCd );
          if (pref && pref.length > 0) {
            this.companyInfo.prefNm = pref[0].prefNm;
          }
        }
      }, (err: any) => {
        this.companyInfo = {
          zip1: null,
          zip2: null,
          prefCd: null,
          prefNm: null,
          addr1: null,
          addr2: null,
          shatenNm: null,
          kyotenNm: null,
          tel1: null,
          tel2: null,
          tel3: null,
          lineQr: null
        };
      });
    });
  }

  onShowConfirmSaveAndExit() {
    this.$refs.saveAndExitDialog.onOpen();
  }

  onConfirmExit() {
    /** 2021-07-19 sh #6989 refactoring for quick mitsumori. [START] */
    // this.$router.push({ name: "reservation" });
    this.$emit("onConfirmExit");
    /** 2021-07-19 sh #6989 refactoring for quick mitsumori. [END] */
  }

  onPaymentsBeforeSettimeout(msec: number = 1000) {
    // デザイン統合用のダミー
  }

  /** 2021-07-28 sh #6989 sub item for quick mitsumori.(priority 2) [START] */
  isCourseSubItem(item: any) {
    if (item && item.rowNum === 0) {
      return "course-sub-item-nm";
    }

    return "";
  }
  /** 2021-07-28 sh #6989 sub item for quick mitsumori.(priority 2) [END] */

  /** 2021-08-24 sh #7361 it does not update seibiList for quick mitsumori. [START] */
  mounted() {
    this.seibiDataUnSubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'InspectSeibi/setSeibiData') {
        this.setListSeibi();
      }
    });
  }

  beforeDestroy() {
    if (this.seibiDataUnSubscribe) {
      this.seibiDataUnSubscribe();
    }
  }
  /** 2021-08-24 sh #7361 it does not update seibiList for quick mitsumori. [END] */

  /** 2021-10-07 sh #7438 implements tech-info-amount for quick estimate preview. [START] */
  get isUseTechInfoAmount() {
    return this.shouhiyou.houteiHiyou.isUseTechInfoAmount == 1;
  }
  /** 2021-10-07 sh #7438 implements tech-info-amount for quick estimate preview. [END] */

  isNotRecommend(item: any) {
    return true; // クイック見積もりはｵｽｽﾒなし
  }

  isHoan(item: any) {
    // クイック見積もりに無償設定はないので条件を変更する
    if ( !item.isHoanKijun ) {
      return 0;
    } else {
      return 2;
    }
  }

}
